"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _util = require("../util");

var _util2 = _interopRequireDefault(_util);

var _Tree = require("../tree/Tree");

var _Tree2 = _interopRequireDefault(_Tree);

var _Select2 = require("../select/Select");

var _Select3 = _interopRequireDefault(_Select2);

var _Trigger = require("../trigger/Trigger");

var _Trigger2 = _interopRequireDefault(_Trigger);

var _data = require("../util/data");

var _util3 = require("../select/util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === "function";
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return "EagerThenable{" + {
            "-1": "pending",
            0: "resolved",
            1: "rejected"
          }[phase] + "}=" + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === "function" ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var TreeSelect = (_dec = _util2.default.reactExtras, _dec(_class = function (_Select) {
  _inherits(TreeSelect, _Select);

  function TreeSelect(props) {
    _classCallCheck(this, TreeSelect);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TreeSelect).call(this, props));

    if (props.fetchNodeDataAction) {
      console.warn("TreeSelect 组件接受属性 fetchNodeDataAction 请替换成 onFetchNodeData");
    }
    _this._treeId = 1;
    var fillOptions = _this.fillOptions;

    _this.fillOptions = function () {
      _this._treeId += 1;
      _this.state.expandedIds = null;
      return fillOptions.apply(undefined, arguments);
    };
    return _this;
  }

  _createClass(TreeSelect, [{
    key: "render",
    value: function render() {
      var _U$classNames,
          _this2 = this;

      var props = _extends({}, this.props);
      var prefixCls = props.prefixCls;
      var triggerClassName = props.triggerClassName;
      var className = props.className;
      var size = props.size;
      var disabled = props.disabled;
      var style = props.style;
      var mode = props.mode;
      var combobox = props.combobox;
      var multiple = props.multiple;
      var maxLength = props.maxLength;
      var showCount = props.showCount;
      var getPopupContainer = props.getPopupContainer;
      var align = props.align;
      var notFoundContent = props.notFoundContent;
      var noSearchIfNoKeyword = props.noSearchIfNoKeyword;
      var _state = this.state;
      var visible = _state.visible;
      var valid = _state.valid;
      var explain = _state.explain;
      var showData = _state.showData;
      var loading = _state.loading;
      var searchword = _state.searchword;
      var value = _state.value;
      var allSelect = _state.allSelect;

      prefixCls += '-select' + (multiple ? '-multiple' : '');
      var showTrigger = mode !== 'view' && !disabled;

      var cls = _util2.default.classNames((_U$classNames = {}, _defineProperty(_U$classNames, "" + prefixCls, true), _defineProperty(_U$classNames, prefixCls + "-combobox", combobox), _defineProperty(_U$classNames, prefixCls + "-sm", size === 'small'), _defineProperty(_U$classNames, prefixCls + "-" + mode, mode === 'view'), _defineProperty(_U$classNames, prefixCls + "-disabled", mode !== 'view' && disabled), _defineProperty(_U$classNames, prefixCls + "-visible", visible), _defineProperty(_U$classNames, className, className), _defineProperty(_U$classNames, 'has-error', !valid), _U$classNames));
      var hasData = (showData || []).length > 0;
      if (visible) {
        if (!hasData && (combobox || !loading && (0, _data.isEmptyString)(notFoundContent))) {
          // 联想输入框没数据时, 或者 notFoundContent 为空且无数据时, 都不显示下拉窗
          visible = false;
        }
        if (this.searching && (0, _data.isEmptyString)(searchword) && noSearchIfNoKeyword) {
          // noSearchIfNoKeyword 为 true 而关键字为空时不显示下拉窗
          visible = false;
        }
      }

      var countContent = void 0;
      if (combobox && mode !== "view" && showCount) {
        var _classNames;

        // 联想输入框编辑态实时计数
        value = getShowValue(value);
        var labelLength = value.label.length;
        var showCountCls = combobox && classNames((_classNames = {}, _defineProperty(_classNames, prefixCls + "-showCount", true), _defineProperty(_classNames, prefixCls + "-showCount-overCount", labelLength > maxLength), _classNames));
        countContent = _react2.default.createElement(
          "span",
          { className: showCountCls },
          _react2.default.createElement(
            "i",
            null,
            labelLength
          ),
          "/",
          maxLength
        );
      }
      return _react2.default.createElement(
        "div",
        { className: cls, style: style, ref: "container" },
        multiple ? this.renderMultiSelect() : this.renderSelect(),
        countContent,
        !valid && _react2.default.createElement(
          "span",
          { className: "has-explain " + prefixCls + "-explain" },
          explain
        ),
        showTrigger && _react2.default.createElement(
          _Trigger2.default,
          { visible: visible,
            className: triggerClassName,
            align: align,
            ref: "trigger",
            autoDestory: align ? align.autoDestory : true,
            equalTargetWidth: align ? align.equalTargetWidth : true,
            getPopupContainer: getPopupContainer,
            target: function target() {
              return (0, _reactDom.findDOMNode)(_this2);
            } },
          this.renderTriggerContent()
        )
      );
    }
    // 渲染弹出框中的内容
    // TODO 文字超长时不折行只省略  并添加 toolTips 来显示全文

  }, {
    key: "renderTriggerContent",
    value: function renderTriggerContent() {
      var _U$classNames2,
          _this3 = this;

      var props = this.props;
      var prefixCls = props.prefixCls;
      var model = props.model;
      var multiple = props.multiple;
      var combobox = props.combobox;
      var notFoundContent = props.notFoundContent;
      var maxLength = props.maxLength;
      var size = props.size;
      var _state2 = this.state;
      var loading = _state2.loading;
      var showData = _state2.showData;
      var value = _state2.value;
      var data = _state2.data;
      var expandedIds = _state2.expandedIds;
      var searchword = _state2.searchword;
      var fetchErrorMessage = _state2.fetchErrorMessage;

      prefixCls = prefixCls + '-select' + (multiple ? '-multiple' : '');

      var hasData = (showData || []).length > 0;

      var outerCls = _util2.default.classNames((_U$classNames2 = {}, _defineProperty(_U$classNames2, prefixCls + "-dropdown", true), _defineProperty(_U$classNames2, prefixCls + "-dropdown-sm", size === 'small'), _U$classNames2));

      if (loading) {
        // 加载中
        return _react2.default.createElement(
          "div",
          { className: outerCls, style: { maxHeight: model.height || 'auto' } },
          _react2.default.createElement(
            "ul",
            { className: outerCls },
            _react2.default.createElement(
              "li",
              { className: prefixCls + "-loading" },
              _react2.default.createElement("i", { className: _data.IconPrefixCls + " " + _data.IconPrefixCls + "-loading" })
            )
          )
        );
      }
      if (multiple && (value || []).length + 1 > maxLength) {
        // 超过最大可选条数
        return _react2.default.createElement(
          "div",
          { className: outerCls, style: { maxHeight: model.height || 'auto' } },
          _react2.default.createElement(
            "ul",
            { className: outerCls },
            _react2.default.createElement(
              "li",
              { className: prefixCls + "-outLength", onClick: this.hideDropdown },
              "您最多只能选择",
              maxLength,
              "条"
            )
          )
        );
      }
      if (!hasData) {
        // 没有数据
        return _react2.default.createElement(
          "div",
          { className: outerCls, style: { maxHeight: model.height || 'auto' } },
          _react2.default.createElement(
            "ul",
            { className: outerCls },
            _react2.default.createElement(
              "li",
              { className: prefixCls + "-notfound", onClick: this.hideDropdown },
              fetchErrorMessage || notFoundContent
            )
          )
        );
      }
      return _react2.default.createElement(
        "div",
        { className: outerCls, style: { maxHeight: model.height || 'auto' } },
        !multiple && _react2.default.createElement(_Tree2.default, _extends({
          key: this._treeId,
          ref: "tree",
          data: data,
          defaultExpandAll: true,
          expandedIds: expandedIds,
          onExpand: function onExpand(expandedIds) {
            return _this3.setState({ expandedIds: expandedIds });
          }
        }, model, {
          filterTreeNode: model.filterTreeNode && function (treeNode) {
            return model.filterTreeNode(treeNode, searchword);
          },
          checkable: false,
          selectedIds: value ? [value.value] : [],
          loadData: this.handleTreeLoadData,
          onSelect: this.handleTreeSelect
        })),
        multiple && _react2.default.createElement(_Tree2.default, _extends({
          key: this._treeId,
          ref: "tree",
          data: data,
          defaultExpandAll: true,
          expandedIds: expandedIds,
          onExpand: function onExpand(expandedIds) {
            return _this3.setState({ expandedIds: expandedIds });
          }
        }, model, {
          filterTreeNode: model.filterTreeNode && function (treeNode) {
            return model.filterTreeNode(treeNode, searchword);
          },
          multiple: true,
          checkable: true,
          checkStrictly: true,
          checkedIds: (value || []).map(function (x) {
            return x.value;
          }),
          selectedIds: (value || []).map(function (x) {
            return x.value;
          }),
          onCheck: this.handleTreeCheck,
          loadData: this.handleTreeLoadData,
          onSelect: this.handleTreeMultiSelect
        }))
      );
    }
  }, {
    key: "handleTreeLoadData",
    value: function handleTreeLoadData(nodeId) {
      return new Promise(function ($return, $error) {
        var _props = this.props;
        var fetchNodeDataAction = _props.fetchNodeDataAction;
        var onFetchNodeData = _props.onFetchNodeData;
        var tree = this.refs.tree;
        return Promise.resolve(_util2.default.promisify(fetchNodeDataAction || onFetchNodeData)(tree.getNode(nodeId))).then(function ($await_1) {
          var _state$data;

          var res = $await_1;
          // throw 'xxx'; // TODO: 这里异常被静默隐藏了？
          var data = (_state$data = this.state.data).concat.apply(_state$data, _toConsumableArray(res));
          return Promise.resolve(this.setStateAsync({
            data: data,
            showData: (0, _util3.getShowData)(data, this.props, this)
          })).then(function ($await_2) {
            return $return();
          }.$asyncbind(this, $error), $error);
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(this));
    }
  }, {
    key: "handleTreeSelect",
    value: function handleTreeSelect(_ref, e) {
      var _this4 = this;

      var _ref2 = _slicedToArray(_ref, 1);

      var id = _ref2[0];

      if (this.props.noChangeIfDuplicated && id == null) return;
      var _props2 = this.props;
      var model = _props2.model;
      var onSelect = _props2.onSelect;
      var onChange = _props2.onChange;
      var showTpl = model.showTpl;
      var showField = model.showField;

      var node = this.refs.tree.getNode(e.nodeId);
      var value = _extends({}, node, {
        value: e.nodeId,
        label: showTpl != null ? _util2.default.template(showTpl, node) : node[showField]
      });
      var oldsearch = this.state.searchword;
      this.setState({ value: value, searchword: '' }, function () {
        _this4.hideDropdown();
        oldsearch && _this4.clearOption();
        onSelect(node, e);
        onChange(value, e);
      });
    }
  }, {
    key: "handleTreeMultiSelect",
    value: function handleTreeMultiSelect(ids, e) {
      var _this5 = this;

      var _props3 = this.props;
      var model = _props3.model;
      var onSelect = _props3.onSelect;
      var onChange = _props3.onChange;
      var clearSearchwordAfterSelect = _props3.clearSearchwordAfterSelect;
      var tree = this.refs.tree;
      var showTpl = model.showTpl;
      var showField = model.showField;

      var valueMap = _util2.default.toObject(this.state.value, 'value');
      var value = ids.map(function (id) {
        var node = tree.getNode(id);
        return node == null ? valueMap[id] : _extends({}, tree.getNode(id), {
          value: id,
          label: showTpl != null ? _util2.default.template(showTpl, node) : node[showField]
        });
      });
      var searchword = this.state.searchword;

      var oldSearch = searchword;
      _reactDom2.default.findDOMNode(this.refs.input).style.width = 50 + 'px'; // 在显示新选项时 先将input的宽度调小 避免trigger定位不准
      this._rememberSelectionHeight();
      clearSearchwordAfterSelect && (searchword = "");
      this.setState({ value: value, searchword: searchword }, function () {
        _this5.calculateNodeWidth();
        if (clearSearchwordAfterSelect && oldSearch) {
          _this5._fetchDataHandle();
        }
        onSelect(tree.getNode(e.nodeId), e);
        onChange(value, e);
        _this5.focusInput();
      });
    }
  }, {
    key: "handleTreeCheck",
    value: function handleTreeCheck(ids, e) {
      this.handleTreeMultiSelect(ids, e);
    }
  }]);

  return TreeSelect;
}(_Select3.default)) || _class);
exports.default = TreeSelect;